import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAnalytics } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { BookingAnalyticsPage } from "./pages/bookings/BookingAnalyticsPage";
import { CommunityFeedSentimentAnalyticsPage } from "./pages/community-feed-sentiment/CommunityFeedSentimentAnalyticsPage";
import { CommunityFeedAnalyticsPage } from "./pages/community-feed/CommunityFeedAnalyticsPage";
import { AdoptionDetailPage } from "./pages/details/adoption/AdoptionDetailPage";
import { ContributionDetailPage } from "./pages/details/contribution/ContributionDetailPage";
import { EngagementDetailPage } from "./pages/details/engagement/EngagementDetailPage";
import { EventAnalyticsPage } from "./pages/events/EventAnalyticsPage";
import { AnalyticsExplorePage } from "./pages/explore/AnalyticsExplorePage";
import { AnalyticsOverviewPage } from "./pages/overview/AnalyticsOverviewPage";
import { TicketAnalyticsPage } from "./pages/tickets/TicketAnalyticsPage";
import { analyticsRoutes } from "./routes";

export const analyticsRoute = [
  {
    path: analyticsRoutes.overview,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <AnalyticsOverviewPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.adoptionDetails,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <AdoptionDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.contributionDetails,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <ContributionDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.engagementDetails,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <EngagementDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.bookingReporting,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <BookingAnalyticsPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.communityFeedReporting,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <CommunityFeedAnalyticsPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.communityFeedSentimentReporting,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <CommunityFeedSentimentAnalyticsPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.eventReporting,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <EventAnalyticsPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.ticketReporting,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <TicketAnalyticsPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.explore,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <AnalyticsExplorePage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreEvents,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <EventAnalyticsPage mode="all" />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreAdoption,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <AdoptionDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreEngagement,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <EngagementDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreContribution,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <ContributionDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreBookings,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <BookingAnalyticsPage mode="all" />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreCommunityFeed,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <CommunityFeedAnalyticsPage mode="all" />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreSentiment,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <CommunityFeedSentimentAnalyticsPage mode="all" />
      </RequireAuth>
    ),
  },
  {
    path: analyticsRoutes.exploreTickets,
    element: (
      <RequireAuth permission={canAccessAnalytics}>
        <TicketAnalyticsPage mode="all" />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
